/**
 * Auth Restore Utility
 * Restores authentication data from URL hash on page load
 */
import { setItem, removeItem } from "./storage";

export const restoreAuthFromHash = () => {
  try {
    const hash = window.location.hash;
    if (hash && hash.includes('auth=')) {
      const authParam = hash.split('auth=')[1];
      if (authParam) {
        const decodedData = JSON.parse(atob(authParam));
        
        // Check if this is superadmin data (from company logout) or company data (from superadmin sign-in)
        if (decodedData.adminToken) {
          // This is superadmin data from company logout - restore superadmin session
          if (decodedData.adminToken) {
            setItem("adminToken", decodedData.adminToken);
          }
          if (decodedData.adminId) {
            setItem("admin_id", decodedData.adminId);
          }
          if (decodedData.appUrl) {
            setItem("appUrl", decodedData.appUrl);
          }
          // Clear any impersonation flags when restoring superadmin session
          removeItem("isImpersonated");
          removeItem("impersonatedBy");
          removeItem("CompanyId");
          removeItem("CompanyUrl");
          removeItem("oldSession");
          removeItem("oldAdminId");
        } else {
          // This is company data from superadmin sign-in - restore company session
          if (decodedData.token) {
            setItem("adminToken", decodedData.token);
          }
          if (decodedData.CompanyId) {
            setItem("CompanyId", decodedData.CompanyId);
          }
          if (decodedData.CompanyUrl) {
            setItem("CompanyUrl", decodedData.CompanyUrl);
          }
          if (decodedData.isImpersonated) {
            setItem("isImpersonated", decodedData.isImpersonated);
          }
          if (decodedData.impersonatedBy) {
            setItem("impersonatedBy", decodedData.impersonatedBy);
          }
          if (decodedData.currentLogoPath) {
            setItem("currentLogoPath", decodedData.currentLogoPath);
          }
          // Restore admin token and adminId for logout functionality
          if (decodedData.oldSession) {
            setItem("oldSession", decodedData.oldSession);
          }
          if (decodedData.oldAdminId) {
            setItem("oldAdminId", decodedData.oldAdminId);
          }
          // Restore APP_URL for logout redirect
          if (decodedData.appUrl) {
            setItem("appUrl", decodedData.appUrl);
          }
        }
        
        // Remove auth parameter from URL hash to clean up
        window.history.replaceState(null, null, window.location.pathname + window.location.search);
      }
    }
  } catch (error) {
    console.error("Error restoring auth from hash:", error);
  }
};

